import { createRoot } from "react-dom/client";
import App from "./App";
import "@/styles/globals.css";

const root = document.getElementById("root")!;
createRoot(root).render(<App />);
